import { useTranslation } from "react-i18next";
import Carrier from "@Components/Carrier/Carrier";
import TotalAmountStrip from "../TotalTopCard/TotalAmountStrip";
import JourneySidebar from "../Sidebar/Sidebar";
import { useStepButtonsPortal } from "../../context";

export default function MobileSidebarDrawer() {
  const { t } = useTranslation();
  const { setPortalContainer } = useStepButtonsPortal();

  return (
    <Carrier
      label={t("Flights.details.summary.bookingSummary")}
      renderTrigger={({ open }) => (
        <div className="fixed bottom-0 start-0 right-0 z-50 bg-background-default rounded-t-xl shadow-[0_-4px_20px_rgba(0,0,0,0.12)]">
          <button className="w-full flex flex-col items-center pt-2 pb-0 focus:outline-none" onClick={open}>
            <div className="w-10 h-0.5 rounded-full bg-border-hover mb-1" />
          </button>
          <TotalAmountStrip />
          <div className="px-5" ref={setPortalContainer} />
        </div>
      )}
      renderSheet={() => (
        <div className="flex-1 overflow-y-auto p-4">
          <JourneySidebar />
        </div>
      )}
    />
  );
}
